import React, { useEffect, useState } from "react";
import axios from "axios";
import ReactModal from "react-modal";
import { IoIosSearch } from "react-icons/io";
import { ObtenerGestionPorSolicitud } from "../Services/Rest";
import CreaGestionEspecial from "../modals/CreaGestionEspecial";

function ConsolidadoEspeciales(props) {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [gestiones, setGestiones] = useState([]);
  const [modalDescripcionOpen, setModalDescripcionOpen] = useState(false);
  const [descripcionSeleccionada, setDescripcionSeleccionada] = useState("");

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  useEffect(() => {
    axios({
      auth: { username: "webapp", password: "762tsfsy9826kk87ytttsf" },
      method: "get",
      url: `${ObtenerGestionPorSolicitud}${props.id}&Origen=Especial`,
    })
      .then((response) => setGestiones(response.data))
      .catch((error) => console.error("Error al obtener gestiones:", error));
  }, [props.id]);

  const renderAdjunto = (adjunto, esGestion = false) => {
    if (adjunto === "") return "";
    const baseUrl = esGestion ? "" : "";
    return (
      <a
        href={`${baseUrl}${adjunto}`}
        className="btn btn-outline-primary"
        download
      >
        Descargar Adjunto
      </a>
    );
  };

  return (
    <>
      <button className="btn btn-secondary" onClick={openModal}>
        <IoIosSearch />
      </button>

      {/* MODAL PRINCIPAL */}
      <ReactModal isOpen={modalIsOpen} onRequestClose={closeModal}>
        <div className="container">
          {/* Información de la Solicitud */}
          <div className="card shadow mb-4">
            <div className="card-header py-3">
              <h6 className="m-0 font-weight-bold text-primary">
                Información de la Solicitud
              </h6>
            </div>
            <div className="card-body">
              <form className="user">
                <div className="form-group row">
                  <div className="col-sm-12">
                    <input
                      type="text"
                      className="form-control"
                      value={`Nombre cliente: ${props.nombreCliente}`}
                      disabled
                    />
                  </div>
                </div>

                <div className="form-group row">
                  <div className="col-sm-12">
                    <textarea
                      className="form-control"
                      value={`Descripción: ${props.descripcion}`}
                      disabled
                    />
                  </div>
                </div>

                <div className="form-group row">
                  <div className="col-sm-6">
                    <input
                      type="text"
                      className="form-control"
                      value={`Línea Servicio: ${props.lineaServicio}`}
                      disabled
                    />
                  </div>
                  <div className="col-sm-6">
                    <input
                      type="text"
                      className="form-control"
                      value={`Título: ${props.titulo}`}
                      disabled
                    />
                  </div>
                </div>

                <div className="form-group row">
                  <div className="col-sm-12">
                    <textarea
                      className="form-control"
                      value={`Observaciones: ${props.observaciones}`}
                      disabled
                    />
                  </div>
                </div>

                <div className="form-group row">
                  <div className="col-sm-6">
                    <input
                      type="text"
                      className="form-control"
                      value={`Usuario: ${props.usuario}`}
                      disabled
                    />
                  </div>
                </div>
                <center>
                  <div className="col-sm-12 mt-2 mb-3">
                    {props.adjunto !== "Sin Adjunto" && (
                      <h5>{renderAdjunto(props.adjunto1)}</h5>
                    )}
                    <button className="btn btn-secondary" onClick={closeModal}>
                      Volver
                    </button>
                  </div>
                </center>
                <hr />
              </form>
            </div>
          </div>

          {/* Información de las Gestiones */}
          <div className="card shadow mb-4">
            <div className="card-header py-3">
              <h6 className="m-0 font-weight-bold text-primary">
                Información Gestiones
              </h6>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <table className="table table-bordered" width="100%">
                  <thead>
                    <tr>
                      <th>Descripción</th>
                      <th>Fecha Creación</th>
                      <th>Adjunto</th>
                      <th>Usuario</th>
                      <th>Estado</th>
                    </tr>
                  </thead>
                  <tbody>
                    {gestiones.map((item, index) => {
                      const textoCompleto = item.descripcionGestion;
                      const textoCorto =
                        textoCompleto.length > 100
                          ? textoCompleto.slice(0, 60) + "..."
                          : textoCompleto;

                      return (
                        <tr key={index}>
                          <td
                            style={{
                              maxWidth: "250px",
                              wordBreak: "break-word",
                              whiteSpace: "normal",
                            }}
                          >
                            <div className="d-flex flex-column">
                              <span>{textoCorto}</span>
                              {textoCompleto.length > 100 && (
                                <button
                                  className="btn btn-sm btn-link mt-1 text-primary text-start p-0"
                                  style={{ alignSelf: "start" }}
                                  onClick={() => {
                                    setDescripcionSeleccionada(textoCompleto);
                                    setModalDescripcionOpen(true);
                                  }}
                                >
                                  Ver más
                                </button>
                              )}
                            </div>
                          </td>
                          <td>{item.fechaCreacion}</td>
                          <td>
                            {item.adjunto === "Sin Adjunto"
                              ? "Sin Adjunto"
                              : renderAdjunto(item.adjunto, true)}
                          </td>
                          <td>{item.usuarioId}</td>
                          <td>{item.estado}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              {/* Botón para crear gestión especial */}
              <CreaGestionEspecial id={props.id} />
            </div>
          </div>
        </div>
      </ReactModal>

      {/* MODAL DE DESCRIPCIÓN COMPLETA */}
      <ReactModal
        isOpen={modalDescripcionOpen}
        onRequestClose={() => setModalDescripcionOpen(false)}
        style={{
          content: {
            maxWidth: "600px",
            margin: "auto",
            padding: "40px",
          },
        }}
      >
        <br></br>
        <h5 className="text-primary mb-3">Descripción completa</h5>
        <div
          style={{
            maxHeight: "300px",
            overflowY: "auto",
            whiteSpace: "pre-wrap",
          }}
        >
          <textarea
            className="form-control"
            value={descripcionSeleccionada}
            readOnly
            rows={26}
            style={{
              resize: "none",
              backgroundColor: "#f9f9f9",
              border: "1px solid #ccc",
              padding: "10px",
              fontSize: "14px",
              borderRadius: "8px",
              width: "100%",
            }}
          />
        </div>
        <div className="text-end mt-3">
          <button
            className="btn btn-secondary"
            onClick={() => setModalDescripcionOpen(false)}
          >
            Cerrar
          </button>
        </div>
      </ReactModal>
    </>
  );
}

export default ConsolidadoEspeciales;
